<template>
    <div class="fullwidth" :class="{'shadowed':b.box_shadow, 'widewidth':b.max}">
        <img :src="b.bild.url" alt="">
    </div>
</template>
<script>
    export default {
        name: "Fullimage",
        props: {b: Object},
    }
</script>
<style scoped lang="scss">
    .fullwidth {
        width: 100%;
        img {
            width: 100%;}
    }
    .widewidth {

        padding: 0;
    }
</style>